import { parseDriveLinkFile } from '../utils/googleDriveLinks';

export const DRIVE_LINKS_URL = `${process.env.PUBLIC_URL || ''}/downloads/drive-links.env`;

export const DESKTOP_RELEASES_URL =
  'https://github.com/techellipticadigim/workloop-distribution/releases';

export const DRIVE_KEYS_BY_ROW = {
  'mac-arm64': ['MAC-ARM64', 'MAC-ARM'],
  'mac-arm64-zip': ['MAC-ARM64-ZIP', 'MAC-ARM-ZIP'],
  'mac-x64': ['MAC-x64', 'MAC-X64'],
  'mac-x64-zip': ['MAC-x64-ZIP', 'MAC-X64-ZIP'],
  'win-portable': ['WIN-EXE'],
  'win-zip': ['WIN-ZIP'],
  'linux-appimage': ['LIN-APPIMAGE'],
  'linux-deb': ['LIN-DEB'],
};

export const DRIVE_LINKS_SOURCE = `
MAC-ARM64=https://github.com/techellipticadigim/workloop-distribution/releases/download/v0.6.0/Workloop-0.6.0-mac-arm64.dmg
MAC-ARM=https://github.com/techellipticadigim/workloop-distribution/releases/download/v0.6.0/Workloop-0.6.0-mac-arm64.dmg
MAC-ARM64-ZIP=https://github.com/techellipticadigim/workloop-distribution/releases/download/v0.6.0/Workloop-0.6.0-mac-arm64.zip
MAC-x64=https://github.com/techellipticadigim/workloop-distribution/releases/download/v0.6.0/Workloop-0.6.0-mac-x64.dmg
MAC-x64-ZIP=https://github.com/techellipticadigim/workloop-distribution/releases/download/v0.6.0/Workloop-0.6.0-mac-x64.zip
WIN-ZIP=https://github.com/techellipticadigim/workloop-distribution/releases/download/v0.6.0/Workloop-0.6.0-win-x64.zip
WIN-EXE=https://github.com/techellipticadigim/workloop-distribution/releases/download/v0.6.0/Workloop-Portable-0.6.0-x64.exe
LIN-DEB=https://github.com/techellipticadigim/workloop-distribution/releases/download/v0.6.0/Workloop-0.6.0-linux-amd64.deb
LIN-APPIMAGE=https://github.com/techellipticadigim/workloop-distribution/releases/download/v0.6.0/Workloop-0.6.0-linux-x86_64.AppImage
`;

export const FALLBACK_DRIVE_LINKS = parseDriveLinkFile(DRIVE_LINKS_SOURCE);

export const driveUrlForRow = (rowId, links = {}) => {
  const keys = DRIVE_KEYS_BY_ROW[rowId] || [];
  for (let i = 0; i < keys.length; i += 1) {
    const url = links[keys[i]];
    if (url) return url;
  }
  return '';
};
